<template>
    <div class="login-page">
        <div class="login-container">
            <h1 class="login-title">後台登入</h1>

            <!-- 錯誤訊息或鎖定提示 -->
            <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
            <div v-if="isLocked" class="lock-message">
                帳號已鎖定至今天 24:00 後。請稍候再試。
            </div>

            <!-- 登入表單 -->
            <form class="login-form" @submit.prevent="handleLogin">
                <label>
                    帳號
                    <input type="text" v-model="username" name="username" :disabled="isLocked" required />
                </label>

                <label>
                    密碼
                    <input type="password" v-model="password" name="password" :disabled="isLocked" required />
                </label>

                <!-- 記住我 (Remember Me) -->
                <label class="remember-me">
                    <input type="checkbox" v-model="rememberMe" :disabled="isLocked" />
                    記住我
                </label>

                <button type="submit" class="btn-login" :disabled="isLocked">
                    登入
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { useAdminSysTempStore } from '@/store/adminSysTempStore.js'


export default {
    name: 'AdminLogin',
    data() {
        return {
            username: '',
            password: '',
            rememberMe: false,      // 新增
            errorMessage: '',
            isLocked: false,
            isOut: false,
        }
    },
    async beforeCreate() {
        // 檢查是否登入
        const useAdminSysTemp = useAdminSysTempStore()
        await useAdminSysTemp.fetchAdminCheckLogin()
        if (!useAdminSysTemp.isLoggedIn) {
            this.$router.push('/admin/login')
        }
    },
    methods: {

        /**
         * 登入
         */
        async handleLogin() {
            // 若已被鎖定，不可登入
            if (this.isOut) {
                this.errorMessage = "密碼錯誤次數過多，請等到明天再嘗試！";
                return
            }

            if (this.isLocked) return
            this.errorMessage = ''

            try {
                const res = await axios.post('/api/admin/login', {
                    username: this.username,
                    password: this.password,
                    rememberMe: this.rememberMe  // 將記住我 送到後端
                })

                if (res.data.success) {
                    const useAdminSysTemp = useAdminSysTempStore();
                    await useAdminSysTemp.fetchSetAdminName(this.username);
                    // 登入成功
                    this.$router.push('/admin/orders')
                } else {
                    // 登入失敗
                    this.handleFail(res.data)
                }
            } catch (error) {
                // 若後端回傳 success=false 或 500, 401, 403 等
                this.handleFail(error.response?.data || {})
            }
        },

        /**
         * 登入失敗後，處理錯誤次數
         */
        handleFail(data) {
            this.isOut = data.isOut || false
            this.errorMessage = data.message || '登入失敗，請檢查帳號密碼。'
            // 這裡可以自行加上「+1 錯誤次數」的邏輯，
            // 若你在後端用 Redis 或 DB 實作，就前端不必做。
        }
    }
}
</script>

<style scoped>
.login-page {
    width: 100%;
    height: 100vh;
    background: linear-gradient(135deg, #2E3A59, #46567A);
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-container {
    width: 360px;
    padding: 2rem;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.login-title {
    margin-bottom: 1rem;
    font-size: 1.5rem;
    color: #2E3A59;
}

.error-message {
    color: #d9534f;
    /* Danger color */
    margin-bottom: 0.5rem;
}

.lock-message {
    color: #d9534f;
    margin-bottom: 1rem;
    font-weight: bold;
}

.login-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.login-form label {
    display: flex;
    flex-direction: column;
    font-size: 0.95rem;
    color: #333;
}

.login-form input {
    margin-top: 0.3rem;
    padding: 0.5rem;
    font-size: 1rem;
}

.remember-me {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
}

.btn-login {
    padding: 0.6rem;
    font-size: 1rem;
    background-color: #2E3A59;
    color: #fff;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.btn-login:hover {
    background-color: #3b4b6b;
}

/* 手機 RWD */
@media (max-width: 480px) {
    .login-container {
        width: 90%;
        padding: 1rem;
    }
}
</style>